import request from "@/utils/Request";

const columnItemUtil = {
  /**
   * 增加阅读数量
   * @param item
   */
  incrementReadQuantity(item) {
    return request({
      url: '/appointment-manager/creditConfig/incrementReadQuantity/' + item.id + '/' + 1,
      method: 'PUT',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    }).then(res => {
      if (res.code === '0000') {
        item.readQuantity = (!item.readQuantity) ? 1 : item.readQuantity + 1;
      }
    }).catch(err => {
    });
  },

  /**
   * 获取栏目的前一个后一个项目
   */
  getNextAndPreviousItem(columnItemList) {
    if (!columnItemList) {
      return;
    }
    let length = columnItemList.length;
    for (let index = 0; index < length; index++) {
      let item = columnItemList[index];
      if (columnItemList.length === 1) {
        item.nextItem = null;
        item.previousItem = null;
        break;
      }

      if (index === 0) {
        item.previousItem = null
        item.nextItem = columnItemList[index + 1]
        continue;
      }

      if (index === columnItemList.length - 1) {
        item.nextItem = null
        item.previousItem = columnItemList[index - 1]
        break;
      }

      item.previousItem = columnItemList[index - 1]
      item.nextItem = columnItemList[index + 1]
    }
  },

}

export default columnItemUtil;
